var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28976 17.1271C13.8373 17.1271 17.9648 10.8743 17.9648 5.45208C17.9648 5.27448 17.9611 5.09768 17.9532 4.92169C18.7544 4.34249 19.4507 3.61969 20 2.79689C19.2648 3.12369 18.4736 3.34368 17.6436 3.44288C18.4908 2.93488 19.1412 2.13129 19.448 1.17332C18.6552 1.64332 17.7772 1.98492 16.8424 2.16934C16.0936 1.37177 15.0276 0.872917 13.8472 0.872917C11.5812 0.872917 9.74363 2.71054 9.74363 4.97568C9.74363 5.29768 9.77963 5.61088 9.85003 5.9113C6.43968 5.7397 3.41563 4.1069 1.39176 1.62411C1.03936 2.23051 0.836166 2.9349 0.836166 3.6865C0.836166 5.11011 1.56059 6.36687 2.66218 7.1021C1.98897 7.0813 1.35656 6.89649 0.803818 6.58889C0.803214 6.60611 0.803211 6.62289 0.803211 6.64129C0.803211 8.62851 2.21762 10.2877 4.09518 10.6637C3.75038 10.7577 3.38761 10.8081 3.01318 10.8081C2.74919 10.8081 2.49198 10.7821 2.24198 10.7341C2.76438 12.3644 4.2792 13.5509 6.07515 13.584C4.67074 14.6848 2.90157 15.3404 0.978781 15.3404C0.647981 15.3404 0.321183 15.3216 0 15.2836C1.81602 16.4476 3.97236 17.1268 6.28998 17.1268",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/TwitterIcon.4e8ca9e07cea724b116653493ee29a00.svg";
export { ForwardRef as ReactComponent };